import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import HeaderV2 from '../components/HeaderV2';
import FooterV2 from '../components/FooterV2';
import FunctionalHeroV2 from '../components/FunctionalHeroV2';
import CartPage from './CartPage';

/**
 * CartV2Page
 * Barista Map 風格 V2 殼：壓縮版 Hero + 奶油色功能區。
 * 內容沿用 CartPage（保留 CartContext / MemberSidebar / LoginModal / 結帳跳轉等所有交易邏輯）。
 *
 * 對應路由：/zh/cart/v2、/en/cart/v2
 * SEO：noindex,follow + canonical 指回舊版 /[lang]/cart
 */
export default function CartV2Page() {
  const location = useLocation();
  const isEn = location.pathname.startsWith('/en');
  const lang = isEn ? 'en' : 'zh';
  const canonicalUrl = `https://www.ongucoffee.com/${lang}/cart`;
  const isPreviewRoute = location.pathname.includes('/v2');

  useEffect(() => {
    const fontId = 'v2-fonts-cart';
    if (!document.getElementById(fontId)) {
      const link = document.createElement('link');
      link.id = fontId;
      link.rel = 'stylesheet';
      link.href =
        'https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;1,400&family=Noto+Serif+TC:wght@300;400;500&display=swap';
      document.head.appendChild(link);
    }
  }, []);

  const eyebrow = isEn ? 'Your Cart' : '購物車';
  const title = isEn ? 'Your Cart' : '購物車';
  const subtitle = isEn
    ? 'Review your selection before brewing in life.'
    : '在前往結帳前，再次確認您挑選的每一支豆。';

  return (
    <>
      {/* /v2 預覽路由：noindex + canonical 指回舊版；換骨後無 /v2，讓內嵌 CartPage 自帶 SEO 接管 */}
      {isPreviewRoute && (
        <Helmet>
          <meta name="robots" content="noindex,follow" />
          <link rel="canonical" href={canonicalUrl} />
        </Helmet>
      )}
      <div className="min-h-screen bg-white">
        <HeaderV2 />
        <FunctionalHeroV2
          eyebrow={eyebrow}
          title={title}
          subtitle={subtitle}
          backgroundImage="https://images.pexels.com/photos/1695052/pexels-photo-1695052.jpeg?auto=compress&cs=tinysrgb&w=1920"
          breadcrumbs={[
            { label: isEn ? 'Home' : '首頁', to: `/${lang}` },
            { label: isEn ? 'Shop' : '線上購物', to: `/${lang}/shop/beans/v2` },
            { label: isEn ? 'Cart' : '購物車' },
          ]}
        />
        <main className="bg-[#f5f1ea]">
          <div className="mx-auto max-w-[1600px] px-4 md:px-8 py-10 md:py-16">
            <CartPage />
          </div>
        </main>
        <FooterV2 />
      </div>
    </>
  );
}
